/**
 * Extensible Talent Pool route detection for app-chrome (header) switching.
 * Add new prefixes or exact paths here when future TP routes are introduced.
 */

/** Path prefixes that belong to Talent Pool (path === prefix OR starts with `${prefix}/`). */
export const TALENT_POOL_ROUTE_PREFIXES = [
  "/talent-pool",
  "/create-talent-pool",
] as const;

/**
 * Exact paths that are Talent Pool but do not share a prefix above.
 * Prefer a prefix when possible; use this for one-off routes.
 */
export const TALENT_POOL_ROUTE_EXACT: readonly string[] = [];

export const normalizePathname = (pathname: string): string => {
  if (!pathname) return "/";
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }
  return pathname;
};

export const isTalentPoolRoute = (pathname: string): boolean => {
  const path = normalizePathname(pathname);

  if (TALENT_POOL_ROUTE_EXACT.includes(path)) {
    return true;
  }

  return TALENT_POOL_ROUTE_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  );
};
